import { CrmEventAttendingStatus } from "@enums/crmEventAttendingStatus.enum";
import { CrmEventType } from "@enums/crmEventType.enum";
import { Model } from "@interfaces/model.interface";

export interface CrmEvent extends Model {
	attendingStatus: CrmEventAttendingStatus;
	endDate: Date;
	eventType: CrmEventType;
	isSensitive: boolean;
	location: string;
	name: string;
	notes: string;
	organiser: string;
	startDate: Date;
}

export class CrmEvent implements CrmEvent {

	constructor(data?: Partial<CrmEvent>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
